<template>
	
	<li>
		<span class="extension">{{ fileExtension }}</span>

		<div class="row">
			<div class="col-12">
				<span class="filename truncate" v-on:click="downloadFile()">{{ file.filename }}</span>
				<span class="d-inline-block text-info mr-2">{{ fileSize }} MB</span>
				<a @click.prevent="confirmDelete()" href="" class="remove-file" v-if="!isSigned">
				<i class="fa fa-trash"></i> Delete File
				</a>
			</div>
		</div>
	</li>
			
</template>

<script>
 
	import Dropzone from 'dropzone'
	import { round, toUpper } from 'lodash'
	import { notify, apiUrl, http } from 'utils'
	import { mapState, mapActions, mapGetters } from 'vuex'

    export default {
        components: {
		},

		props: {
			file: {
				required: true,
				type: Object
			},

			index: {
				required: true,
				type: Number
			}
		},


        data: function () {
            return {
				
            }
        },
        
        computed: {
			...mapGetters('opportunity', ['isSigned']),
			fileSize () {
				return round(this.file.file_size / 1000000, 2)
			},

			fileExtension () {
				return toUpper(this.file.extension)
			}
        },
		
        methods: {
			...mapActions('opportunity/documents', {
				deleteSingle: 'deleteSingle'
			}),
			async downloadFile () {
				if (this.file.id) {
					window.location.href = apiUrl(`files/${this.file.id}`)
				}

				return Promise.resolve()
			},
			async deleteFile() {
				return this.deleteSingle(this.file.id)
			},
			confirmDelete() {
				this.$swal(
                    {
                        title: 'Delete File', 
                        html: 'Are you sure you want to delete the file: '+this.file.filename+'?',
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Delete',
                    }).then( () => {
                        this.deleteFile();
                    }, function() {
                });
			}
			
        }
    }
</script>
